<div class="selfie-view-modal">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ dateTime || 'Foto do colaborador' }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="selfie-image-container" *ngIf="selfieImageBase64">
      <img
        [src]="selfieImageBase64"
        alt="Foto do colaborador"
        class="selfie-image"
      />
    </div>
    <div class="no-image" *ngIf="!selfieImageBase64">
      <p>Foto não disponível</p>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="close()"
    >
      FECHAR
    </button>
  </div>
</div>

